module.exports = __webpack_public_path__ + "static/media/address-icon.461b7ade.png";